/*
  Tab attention script — Rennoa
  ─────────────────────────────────────────────────────────────
  When a visitor switches to another tab on a product or cart
  page, the browser tab:
    1. scrolls a ticker cycling through 2–3 localized messages
    2. shows a red alert dot on the favicon
  Everything is restored the moment they come back.

  Locales:
    rennoa.dk            → Danish
    rennoa.eu            → English (default)
    rennoa.eu/sv-se/...  → Swedish
    rennoa.eu/no-nb/...  → Norwegian

  Loaded from theme.liquid, only on product + cart templates:

    {% if template contains 'product' or template contains 'cart' %}
      <script src="{{ 'tab-attention.js' | asset_url }}" defer></script>
    {% endif %}

  Note: browsers throttle timers in background tabs to ~1 tick
  per second, so the ticker scrolls at a calm, steady pace when
  the tab is hidden. That is expected behavior, not a bug.
*/
(function () {
  function init() {
    var host = window.location.hostname.replace(/^www\./i, "").toLowerCase();
    var path = window.location.pathname.toLowerCase();

    /* ── 1. Locale detection ─────────────────────────────── */
    var locale = "en";
    if (host === "rennoa.dk") {
      locale = "da";
    } else if (host === "rennoa.eu") {
      if (/^\/sv-se(\/|$)/.test(path)) locale = "sv";
      else if (/^\/no-nb(\/|$)/.test(path)) locale = "no";
    }

    /* ── 2. Scope: product + cart pages only ─────────────── */
    // Safety net — theme.liquid already gates by template, but this
    // keeps the script harmless if it ever loads somewhere else.
    var cleanPath = path.replace(/^\/(sv-se|no-nb)(?=\/|$)/, "");
    var isProduct = cleanPath.indexOf("/products/") === 0;
    var isCart = cleanPath === "/cart" || cleanPath.indexOf("/cart/") === 0;
    if (!isProduct && !isCart) return;

    /* ── 3. Localized messages ───────────────────────────── */
    var messagesByLocale = {
      da: ["👉 Glem ikke det her...", "🛒 Din kurv venter på dig...", "✨ Kom tilbage og kig..."],
      sv: ["👉 Glöm inte det här...", "🛒 Din varukorg väntar på dig...", "✨ Kom tillbaka och titta..."],
      no: ["👉 Ikke glem dette...", "🛒 Handlekurven din venter...", "✨ Kom tilbake og se..."],
      en: ["👉 Don't forget this...", "🛒 Your cart is waiting...", "✨ Come back and take a look..."]
    };

    // Array.from splits into full characters so emojis never break mid-scroll
    var chars = Array.from(messagesByLocale[locale].join("  •  ") + "  •  ");

    /* ── 4. Favicon alert dot ────────────────────────────── */
    var faviconLink = document.querySelector('link[rel~="icon"]');
    var originalFavicon = faviconLink ? faviconLink.href : null;
    var badgedFavicon = null;

    (function buildBadgedFavicon() {
      var size = 64;
      var canvas = document.createElement("canvas");
      canvas.width = canvas.height = size;
      var ctx = canvas.getContext("2d");
      if (!ctx) return;

      function finish() {
        // Red dot with a white ring, top-right — like an unread badge
        ctx.beginPath();
        ctx.arc(size - 13, 13, 11, 0, Math.PI * 2);
        ctx.fillStyle = "#ff2d55";
        ctx.fill();
        ctx.lineWidth = 3;
        ctx.strokeStyle = "#ffffff";
        ctx.stroke();
        try {
          badgedFavicon = canvas.toDataURL("image/png");
        } catch (e) {
          badgedFavicon = null; // cross-origin favicon without CORS — skip the badge
        }
      }

      if (originalFavicon) {
        var img = new Image();
        img.crossOrigin = "anonymous"; // Shopify CDN sends CORS headers
        img.onload = function () {
          ctx.drawImage(img, 0, 0, size, size);
          finish();
        };
        img.onerror = finish; // couldn't load the favicon — badge on transparent
        img.src = originalFavicon;
      } else {
        finish();
      }
    })();

    function setFavicon(href) {
      if (!href) return;
      if (!faviconLink) {
        faviconLink = document.createElement("link");
        faviconLink.rel = "icon";
        document.head.appendChild(faviconLink);
      }
      faviconLink.href = href;
    }

    /* ── 5. Ticker + visibility handling ─────────────────── */
    var TICK_MS = 400; // background tabs are throttled to ~1s per tick by the browser
    var timer = null;
    var pos = 0;
    var originalTitle = document.title;

    function startEffect() {
      document.title = chars.join("");
      setFavicon(badgedFavicon);
      timer = setInterval(function () {
        pos = (pos + 1) % chars.length;
        document.title = chars.slice(pos).concat(chars.slice(0, pos)).join("");
      }, TICK_MS);
    }

    function stopEffect() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
      pos = 0;
      document.title = originalTitle;
      setFavicon(originalFavicon);
    }

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        // Capture the latest title — the theme may have changed it while browsing
        originalTitle = document.title;
        startEffect();
      } else {
        stopEffect();
      }
    });
  }

  // Runs correctly whether the script loads with defer, in <head>, or late in <body>
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();